import React from 'react';
import { Box, Typography, Divider, Link } from '@mui/material';
import Logo from '../../assets/img/Stefanini_logo.webp';

const styles = {
  titleContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  logoBox: {
    height: [15, 35],
    marginRight: 1,
  },
  divider: {
    height: 'auto',
    width: 4,
    borderColor: 'white',
  },
  heading: {
    marginLeft: 1,
    fontFamily: '"Montserrat Subrayada", sans-serif;',
    fontWeight: 'bolder',
    fontSize: [15, 25],
  },
};

export function AppTitle(): JSX.Element {
  return (
    <Box sx={styles.titleContainer}>
      <Link href="https://stefanini.ro/">
        <Box
          component="img"
          sx={styles.logoBox}
          alt="Logo Stefanini"
          src={Logo}
        />
      </Link>
      <Divider orientation="vertical" sx={styles.divider} />
      <Typography variant="h5" component="div" sx={styles.heading}>
        Tempo
      </Typography>
    </Box>
  );
}
